import type { ComponentProps } from "react"
import { ToggleGroup as ToggleGroupBase } from "@/v2-ui/toggleGroup/base/ToggleGroupBase"

export type ToggleGroupProps = ComponentProps<typeof ToggleGroupBase>

function ToggleGroup(props: ToggleGroupProps) {
  const { className, ...toggleGroupBaseProps } = props
  return <ToggleGroupBase className={className} {...toggleGroupBaseProps} />
}

export default ToggleGroup
